<template>
  <v-container>
    <!-- Componente Breadcrumbs -->
    <Breadcrumbs :breadcrumbs="breadcrumbs" @navigate="navigateTo" />

    <!-- Vista para espacios -->
    <template v-if="currentLevel === 'espacios'">
      <EspaciosTable @viewDeportes="toDeportes" />
    </template>

    <!-- Vista para deportes -->
    <template v-if="currentLevel === 'deportes'">
      <DeportesTable :espacio="selectedEspacio" :deportes="deportes" @viewLigas="toLigas" />
    </template>

    <!-- Vista para ligas -->
    <template v-if="currentLevel === 'ligas'">
      <LigasTable :deporte="selectedDeporte" @viewEquipos="toEquipos" />
    </template>

    <!-- Vista para equipos -->
    <template v-if="currentLevel === 'equipos'">
      <EquiposTable :liga="selectedLiga" @viewJugadores="toJugadores" />
    </template>

    <!-- Vista para jugadores -->
    <template v-if="currentLevel === 'jugadores'">
      <JugadoresTable :equipo="selectedEquipo" />
    </template>
  </v-container>
</template>

<script>
import EspaciosTable from '@/views/catalogo/ArbolUA/EspaciosTable.view.vue'
import Breadcrumbs from '@/components/Arbol/Breadcrumb'
import DeportesTable from '@/views/catalogo/ArbolUA/DeportesTable.view.vue'
import LigasTable from '@/views/catalogo/ArbolUA/LigasTable.view.vue'
import EquiposTable from '@/views/catalogo/ArbolUA/EquiposTable.view.vue'
import JugadoresTable from '@/views/catalogo/ArbolUA/JugadoresTable.view.vue'

export default {
  name: 'TreeView',
  components: {
    EspaciosTable,
    Breadcrumbs,
    DeportesTable,
    LigasTable,
    EquiposTable,
    JugadoresTable
  },
  data () {
    return {
      currentLevel: 'espacios',
      breadcrumbs: [{ text: 'ESPACIOS', level: 'espacios' }],
      selectedEspacio: null,
      selectedDeporte: null,
      selectedLiga: null,
      selectedEquipo: null,
      deportes: [] // Almacena deportes para el espacio seleccionado
    }
  },
  mounted () {
    // Obtener el espacioId de los parámetros de consulta
    console.log('Equipos en el componente padre:', this.equipos)
    const espacioId = this.$route.query.espacio_id

    // Si hay un espacioId, navega a la vista de deportes
    if (espacioId) {
      this.toDeportes({ id: espacioId }) // Llama a la función con un objeto que contenga el ID
    }
  },
  methods: {
    // Cambia a nivel de deportes
    toDeportes (espacio) {
      this.selectedEspacio = espacio
      this.breadcrumbs.push({ text: espacio.nombre, level: 'deportes' })
      this.currentLevel = 'deportes'
      console.log(`Navegando a Deportes: ${espacio.nombre}`)
      console.log(`Navegando a Deportes: ${espacio.id}`)
    },
    // Cambia a nivel de ligas
    toLigas (deporte) {
      this.selectedDeporte = deporte // Guardar el objeto deporte
      this.breadcrumbs.push({ text: deporte.nombre.deporte.nombre, level: 'ligas' }) // Aquí usamos nombre, asegúrate de que existe
      this.currentLevel = 'ligas' // Cambiar el nivel actual
      // Si quieres imprimir cada elemento del array descripcion
      console.log(`Navegando a liga: ${deporte.nombre.deporte.nombre}`) // Imprime el nombre del deporte
      console.log(`Navegando a liga: ${deporte.id}`) // Imprime el ID del deporte
    },
    // Cambia a nivel de equipos
    toEquipos (liga) {
      this.selectedLiga = liga
      this.breadcrumbs.push({ text: liga.nombre.liga.categoria, level: 'equipos' })
      this.currentLevel = 'equipos'
      console.log(`Navegando a equipo: ${liga.nombre.liga.categoria}`) // Imprime el nombre del deporte
      console.log(`Navegando a equipo: ${liga.id}`) // Imprime el ID del deporte
    },
    // Cambia a nivel de jugadores
    toJugadores (equipo) {
      this.selectedEquipo = equipo
      this.breadcrumbs.push({ text: equipo.nombre.equipo, level: 'jugadores' })
      this.currentLevel = 'jugadores'
      console.log(`Navegando a jugadores: ${equipo.nombre.equipo}`) // Imprime el nombre del deporte
      console.log(`Navegando a jugadores: ${equipo.id}`)
    },
    // Navega a un nivel específico del breadcrumb
    navigateTo (index) {
      this.breadcrumbs = this.breadcrumbs.slice(0, index + 1)
      this.currentLevel = this.breadcrumbs[index].level

      if (this.currentLevel === 'espacios') {
        this.resetSelections()
      } else if (this.currentLevel === 'deportes') {
        this.selectedDeporte = null
        this.selectedLiga = null
        this.selectedEquipo = null
      } else if (this.currentLevel === 'ligas') {
        this.selectedLiga = null
        this.selectedEquipo = null
      } else if (this.currentLevel === 'equipos') {
        this.selectedEquipo = null
      }
    },
    // Método para resetear las selecciones
    resetSelections () {
      this.selectedEspacio = null
      this.selectedDeporte = null
      this.selectedLiga = null
      this.selectedEquipo = null
      this.deportes = []
    }
  }
}
</script>

<style scoped>
/* Estilos personalizados */
</style>
